var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image-503",attrs:{"loading":"lazy","src":_vm.getImage(),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }